module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DataTablePage', {
    attrs: {
      "pid": "parentId",
      "cid": "id",
      "mainColumn": "name",
      "longColumn": "name",
      "resource": "meterPayload/area",
      "title": "区域管理",
      "label": "区域",
      "labelName": "name",
      "formLabelWidth": 4,
      "isTree": true,
      "amapVisible": true,
      "operation": _vm.operation,
      "operationWidth": 120,
      "toolbar": _vm.toolbar,
      "tableFullList": _vm.tableFullList,
      "tableInitList": _vm.tableInitList,
      "filterFullList": _vm.filterFullList,
      "filterInitList": _vm.filterInitList,
      "createList": _vm.createList,
      "updateList": _vm.updateList,
      "createFormValues": _vm.createFormValues,
      "columns": _vm.columns
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9db6d8aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/NB/Area.vue
// module id = 1794
// module chunks = 1